class TabbedContent extends HTMLElement {
  constructor() {
    super();

    // Detect which tab type this instance should control
    if (this.querySelector('.wt-size-guide__tab')) {
      this.tabPrefix = 'wt-size-guide__tab';
      this.panelPrefix = 'wt-size-guide__panel';
    } else {
      this.tabPrefix = 'wt-tabbed-content__tab';
      this.panelPrefix = 'wt-tabbed-content__panel';
    }

    // Scope tabs and panels inside this component only
    this.tabElements = this.querySelectorAll(`.${this.tabPrefix}`);
    this.panelElements = this.querySelectorAll(`.${this.panelPrefix}`);
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.tabElements.forEach(tab => tab.replaceWith(tab.cloneNode(true)));
  }

  init() {
    if (!this.tabElements.length || !this.panelElements.length) return;

    // Accessibility setup
    this.tabElements.forEach(tab => tab.setAttribute('role', 'tab'));
    this.panelElements.forEach(panel => panel.setAttribute('role', 'tabpanel'));

    // Activate first tab by default
    this.setActiveTab(0);

    // Event listeners
    this.tabElements.forEach((tab, index) => {
      tab.addEventListener('click', () => this.setActiveTab(index));
      tab.addEventListener('keydown', (e) => this.handleKeyNavigation(e, index));
    });
  }

  handleKeyNavigation(e, index) {
    const keys = ['Enter', ' ', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (!keys.includes(e.key)) return;
    e.preventDefault();

    const totalTabs = this.tabElements.length;
    let newIndex = index;

    switch (e.key) {
      case 'Enter':
      case ' ':
        this.setActiveTab(index);
        break;
      case 'ArrowLeft':
        newIndex = index > 0 ? index - 1 : totalTabs - 1;
        break;
      case 'ArrowRight':
        newIndex = index < totalTabs - 1 ? index + 1 : 0;
        break;
      case 'Home':
        newIndex = 0;
        break;
      case 'End':
        newIndex = totalTabs - 1;
        break;
    }

    if (newIndex !== index) {
      this.setActiveTab(newIndex);
      this.tabElements[newIndex].focus();
    }
  }

  setActiveTab(index) {
    // Reset all tabs
    this.tabElements.forEach(tab => {
      tab.classList.remove(`${this.tabPrefix}--active`);
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    });

    this.panelElements.forEach(panel => {
      panel.classList.remove(`${this.panelPrefix}--active`);
      panel.setAttribute('aria-hidden', 'true');
    });

    // Activate selected tab
    const activeTab = this.tabElements[index];
    const activePanel = this.panelElements[index];

    if (activeTab && activePanel) {
      activeTab.classList.add(`${this.tabPrefix}--active`);
      activeTab.setAttribute('aria-selected', 'true');
      activeTab.setAttribute('tabindex', '0');

      activePanel.classList.add(`${this.panelPrefix}--active`);
      activePanel.setAttribute('aria-hidden', 'false');
    }
  }
}

customElements.define('tabbed-content', TabbedContent);
